var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWand = function SvgWand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#wand_svg__a)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "m43.334 46.667-10-10m16.7-25v-5m13.132 10.202 3.535-3.536m-3.535 30L66.7 46.87m-30-30-3.535-3.536M68.368 30h5m-52.93 39.562 30.791-30.79c1.32-1.32 1.98-1.98 2.227-2.742.218-.67.218-1.39 0-2.06-.247-.761-.907-1.421-2.227-2.741l-2.457-2.458c-1.32-1.32-1.98-1.98-2.742-2.227a3.33 3.33 0 0 0-2.06 0c-.76.247-1.42.907-2.74 2.227L10.437 59.562c-1.32 1.32-1.98 1.98-2.227 2.741a3.33 3.33 0 0 0 0 2.06c.247.762.907 1.422 2.227 2.742l2.458 2.457c1.32 1.32 1.98 1.98 2.74 2.228.67.217 1.392.217 2.061 0 .761-.248 1.421-.908 2.741-2.228"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wand_svg__a",
    x1: 67.573,
    x2: -62.953,
    y1: 8.469,
    y2: 58.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })))));
};
export default SvgWand;